import * as React from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames/bind';
import CircularProgress from '@material-ui/core/CircularProgress';

import FieldInfoItem from './FieldInfoItem';
import SnapshotList from './SnapshotsList';
import * as MapFieldCreators from '../../creators/mapField';
import * as MapFildSelectors from '../../selectors/mapField';
import * as MapFieldActions from '../../actions/mapField';
import * as MapFieldListActions from '../../actions/mapFieldList';
import fieldItemList from './utils/fields';
import get from 'lodash-es/get';

import State from '../../interfaces/states/State';

interface DispatchProps {
  loadField: (fieldId: number) => void;
  setFieldId: (fieldId: number) => void;
  setCurrentSnapTile: (snap: any) => void;
  setCurrentDrawLayer: (layer: number[][]) => void;
  setCurrentCenter: (center: number[]) => void;
}

interface OwnProps {
  field: any;
  isError: boolean;
  isLoading: boolean;
  fieldId: number;
  mapFieldsById: any;
  isFieldOrderLoaded: boolean;
}

interface Props extends DispatchProps, OwnProps {}

const MapField = (props: Props) => {
  const {
    field,
    loadField,
    isLoading,
    setFieldId,
    fieldId,
    mapFieldsById,
    setCurrentSnapTile,
    isFieldOrderLoaded,
    setCurrentDrawLayer,
    setCurrentCenter,
  } = props;

  const loadCurrentField = React.useCallback(() => {
    setCurrentDrawLayer(field.geometry.coordinates);
    setCurrentCenter(field.properties.center.coordinates);
    setFieldId(field.id);
    loadField(field.id.toString());
  }, [field]);

  const loaderClassNames = classNames('map-field_loader', {
    'd-block': isLoading,
    'd-none' : !isLoading,
  });

  return (
    <div className='map-field d-flex flex-column'>
      {
        fieldItemList.map((fieldItem) => (
          <FieldInfoItem
            key={fieldItem.name}
            value={get(field, fieldItem.value)}
            name={fieldItem.name} />
        )
        )
      }
      <div className='snap-container d-flex'>
        <button
          onClick={loadCurrentField}
          className='primary-button map-button'>{'Load Tiles'}</button>
        {
          !!isFieldOrderLoaded &&
          <SnapshotList
            setCurrentDrawLayer={setCurrentDrawLayer}
            fieldId={fieldId}
            id={field.id}
            setCurrentSnapTile={setCurrentSnapTile}
            snaphotList={mapFieldsById[fieldId].data.results} />
        }
      </div>
      <div className={loaderClassNames}>
        {!!isLoading && fieldId === field.id && <CircularProgress />}
      </div>
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    isError: MapFildSelectors.isError$(state),
    isLoading: MapFildSelectors.isLoading$(state),
    fieldId: MapFildSelectors.fieldId$(state),
    mapFieldsById: MapFildSelectors.mapFieldsById$(state),
    isFieldOrderLoaded: MapFildSelectors.isFieldOrderLoaded$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    loadField: dispatchProps.loadField,
    setFieldId: dispatchProps.setFieldId,
    setCurrentSnapTile: dispatchProps.setCurrentSnapTile,
    setCurrentDrawLayer: dispatchProps.setCurrentDrawLayer,
    setCurrentCenter: dispatchProps.setCurrentCenter,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    loadField: MapFieldCreators.fetchMapField,
    setFieldId: MapFieldActions.setFieldId,
    setCurrentSnapTile: MapFieldActions.setCurrentSnapTile,
    setCurrentDrawLayer: MapFieldListActions.setCurrentDrawLayer,
    setCurrentCenter: MapFieldListActions.setCurrentCenter,
  }, mergeProps
)(MapField);
